import React, { useState } from 'react';
import { AiComponentJsVariable } from '@/pkg/ai';
import { StackedInputGroupWrapper } from '@/features/editor/widgets/shared/ai-editing-layout/inputs/shared/shared';
import { GenericJsStringInput } from '@/features/editor/widgets/shared/ai-editing-layout/inputs/js/js-string-input';
import { GenericJsNumberInput } from '@/features/editor/widgets/shared/ai-editing-layout/inputs/js/js-number-input';
import { GenericJsBooleanInput } from '@/features/editor/widgets/shared/ai-editing-layout/inputs/js/js-boolean-input';
import { useOnChangeDebounced } from '@/components/hooks/use-on-change';
import { GenericJsObjectInput } from '@/features/editor/widgets/shared/ai-editing-layout/inputs/js/js-object-input';
import { GenericJsRecsStrategyInput } from '@/features/editor/widgets/shared/ai-editing-layout/inputs/js/js-recs-strategy-input';

export interface GenericJsVariableInputProps {
  component: AiComponentJsVariable;
  getJsVariables?: () => AiComponentJsVariable[];
  setJsVariable?: (variable: AiComponentJsVariable) => void;
}

export function GenericJsVariableInput({
  component,
  getJsVariables,
  setJsVariable,
}: GenericJsVariableInputProps) {
  const [variable, setVariable] = useState(
    getJsVariables().find((v) => v.variable === component.variable),
  );

  const onChange = (value: string) => {
    setVariable((prev) => ({ ...prev, value }));
  };

  useOnChangeDebounced(
    () => {
      setJsVariable?.(variable);
    },
    500,
    [variable],
  );

  const isObject = [`object`, `array`].includes(variable.variableType);
  const isRecsConfig =
    isObject && variable.value.includes(`recommendationOptions`);

  return (
    <StackedInputGroupWrapper style={{ padding: 0 }}>
      {variable.variableType === `string` && (
        <GenericJsStringInput value={variable.value} onChange={onChange} />
      )}
      {variable.variableType === `number` && (
        <GenericJsNumberInput value={variable.value} onChange={onChange} />
      )}
      {variable.variableType === `boolean` && (
        <GenericJsBooleanInput value={variable.value} onChange={onChange} />
      )}
      {isObject && !isRecsConfig && (
        <GenericJsObjectInput value={variable.value} onChange={onChange} />
      )}
      {isObject && isRecsConfig && (
        <GenericJsRecsStrategyInput
          variableName={variable.selector}
          value={variable.value}
          onChange={onChange}
        />
      )}
    </StackedInputGroupWrapper>
  );
}
